<template>
  <WdsModal
    :show="isOpen"
    :title="$t('Import timesheets')"
    data-test="timesheet-import-modal"
    @cancel="emit('close')"
  >
    <!-- The template download, upload, review and result steps each add their screen here. -->
    <div data-test="timesheet-import-modal-content"></div>
    <template #footer>
      <div class="tw-flex tw-justify-end">
        <WdsButton data-test="timesheet-import-modal-close-button" @click="emit('close')">
          {{ $t('Close') }}
        </WdsButton>
      </div>
    </template>
  </WdsModal>
</template>

<script setup lang="ts">
import { WdsButton, WdsModal } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'

defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const { $t } = useTranslation()
</script>
